import { Box } from '@wix/design-system';
import { Footer as LoggedInFooter } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import s from './PageFooter.scss';
import { useCurrentModule } from '../ModuleProvider';
export const PageFooter = () => {
  const module = useCurrentModule();
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    direction: "vertical",
    className: s.footer
  }, /*#__PURE__*/React.createElement(LoggedInFooter, {
    borderTop: "none",
    marginBottom: "SP2",
    isLoggedIn: true,
    onLinkClick: (_, linkCode) => {
      module.internals.bi.onFooterLinkClick == null || module.internals.bi.onFooterLinkClick({
        linkCode
      });
    }
  }));
};
//# sourceMappingURL=PageFooter.js.map